module.exports = __webpack_public_path__ + "img/NA.07a5bb8d.png";